import React from "react";
import AudioPlayer from "../components/AudioPlayer";

const OurWorks = () => {
  // const videoLinks = [
  //   {
  //     title: "BV Guide",
  //     url: "https://www.instagram.com/reel/DBLwzgcK2Ob/?utm_source=ig_web_copy_link&igsh=MWJ6azdmc20xMnR2Yg==",
  //   },
  //   {
  //     title: "Vocal Overdubs",
  //     url: "https://www.instagram.com/reel/DMu9hteqo2V/?utm_source=ig_web_copy_link&igsh=MXF2NGtnOTVzY3VoNA==",
  //   },
  //   {
  //     title: "Rehearsal/Soundcheck",
  //     url: "https://www.instagram.com/reel/DHCBArbqqiF/?utm_source=ig_web_copy_link&igsh=MTRwZGFzaWY0Z3N4cA==",
  //   },
  //   {
  //     title: "Watch 2 people become a choir",
  //     url: "https://www.instagram.com/reel/C_YTxdUKLB_/?utm_source=ig_web_copy_link&igsh=NXg4Ymx1aXM4aXY0",
  //   },
  //   {
  //     title: "Lead Vocal Production with Kweku Kwame",
  //     url: "https://www.instagram.com/reel/C4VpR2Qq-vE/?utm_source=ig_web_copy_link&igsh=YXZhODcxaWhvY2l3",
  //   },
  //   {
  //     title: "Great time working with Edward Nene Azu",
  //     url: "https://www.instagram.com/reel/C4VpR2Qq-vE/?utm_source=ig_web_copy_link&igsh=YXZhODcxaWhvY2l3",
  //   },
  //   {
  //     title: "Vocal Rehearsal",
  //     url: "https://www.instagram.com/reel/C-72S6Dq_Fj/?utm_source=ig_web_copy_link&igsh=MW5wcjB6bzl3dXR0eQ==",
  //   },
  // ];

  // SECTION 1: Vocal Productions (Existing items)
  const vocalProductions = [
    {
      title: "Living Water",
      description: "Timestamps: 1:23, 3:03, 5:14, 5:26, 5:43",
      src: "/audios/living.mp3",
    },
    {
      title: "Gye Wayeyi BGVs",
      description: "Timestamps: 1:15, 2:05, 2:16, 4:04, 6:02, 6:11",
      src: "/audios/gye.mp3",
    },
    {
      title: "Mensuro",
      description: "Timestamps: 2:16, 6:11",
      src: "/audios/Mensuro.mp3",
    },
    {
      title: "Spirit of Adonai",
      description: "Timestamps: 1:07, 2:15, 5:00",
      src: "/audios/spirit.mp3",
    },
    {
      title: "Unbelief",
      description: "Timestamps: 2:24, 5:01, 6:38, 7:06",
      src: "/audios/Unbelief.mp3",
    },
    {
      title: "Envoys BVs",
      description: "Timestamps: 0:31, 1:35, 4:25, 5:38",
      src: "/audios/envoys.mp3",
    },
    {
      title: "Who You Are",
      description: "Timestamps: 1:41, 4:03, 4:25",
      src: "/audios/who.mp3",
    },
    {
      title: "Shekere BV",
      src: "/audios/shekere.mp3",
    },
    {
      title: "Praise BV",
      src: "/audios/praise.mp3",
    },
    {
      title: "Born of His Spirit",
      description: "Timestamps: 0:01, 3:34, 3:52, 4:41, 4:57",
      src: "/audios/born.mp3",
    },
    {
      title: "Do a new thing",
      description: "Timestamps: 0:01, 1:09, 3:31",
      src: "/audios/do.mp3",
    },
  ];

  // SECTION 2: Songs Fully Written (Add your new songs here)
  const songsFullyWritten = [
    {
      title: "Hallelujah",
      description: "Written/Composed, Arranged and Directed by Sitso",
      src: "/audios/hallelujah.mp3",
    },
    {
      title: "Searched All Over",
      description: "Written/Composed, Arranged and Directed by Sitso",
      src: "/audios/searched.mp3",
    },
    {
      title: "I Will Find Rest",
      description: "Written/Composed, Arranged and Directed by Sitso",
      src: "/audios/findrest.mp3",
    },
  ];

  // SECTION 3: Songs Co-written
  const songsCoWritten = [
    {
      title: "Amen",
      description: "Co-written, Arranged and Directed by Sitso",
      src: "/audios/amen.mp3",
    },
    {
      title: "Not To Fail",
      description: "Co-written, Arranged and Directed by Sitso",
      src: "/audios/nottofail.mp3",
    },
    {
      title: "Matwen",
      description: "Co-written, Arranged and Directed by Sitso",
      src: "/audios/matwen.mp3",
    },
  ];

  // Helper function to render a list of audio cards
  const renderAudioSection = (title, items, showNote = false) => {
    if (items.length === 0) return null; // Don't show section if empty

    return (
      <div style={{ marginBottom: "3rem" }}>
        <h3 style={{ marginTop: "1rem", borderBottom: "2px solid #eee", paddingBottom: "0.5rem" }}>
            {title}
        </h3>
        
        {showNote && (
          <p
            style={{
              fontSize: "0.95rem",
              color: "#b9202a",
              marginBottom: "1rem",
              marginTop: "0.5rem",
              fontStyle: "italic",
            }}
          >
            NOTE: Check the <strong>Timestamps</strong> under each track for key
            moments worth listening to!
          </p>
        )}

        <div className="works-grid">
          {items.map((a, i) => (
            <div key={i} className="work-card audio-card">
              <div className="work-title">{a.title}</div>

              {a.description && (
                <p
                  style={{
                    fontSize: "0.9rem",
                    color: "#a31818ff",
                    marginTop: "0.25rem",
                    marginBottom: "0.75rem",
                  }}
                >
                  {a.description}
                </p>
              )}

              <AudioPlayer src={a.src} />
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <section style={{ padding: "2rem" }}>
      <h1 style={{ marginBottom: "1rem" }}>Sound Gallery</h1>

      {/* 1. Vocal Productions */}
      {renderAudioSection("Vocal Productions", vocalProductions, true)}

      {/* 2. Songs Fully Written */}
      {renderAudioSection("Songs Fully Written", songsFullyWritten)}

      {/* 3. Songs Co-written */}
      {renderAudioSection("Songs Co-written", songsCoWritten)}

      {/* 🎥 Videos */}
      {/* <h3 style={{ marginTop: "1.5rem", borderBottom: "2px solid #eee", paddingBottom: "0.5rem" }}>Videos</h3>
      <div className="works-grid">
        {videoLinks.map((video, idx) => (
          <div key={idx} className="work-card video-card">
            <a
              href={video.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div
                style={{
                  background: "#000",
                  height: "200px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "10px",
                  color: "white",
                  fontWeight: "600",
                  fontSize: "1.1rem",
                }}
              >
                ▶ {video.title}
              </div>
            </a>
          </div>
        ))}
      </div> */}
    </section>
  );
};

export default OurWorks;